'use client';

import urls from 'urls';
import {saveUserDataToLocalStorage} from '../../utils/auth/utils';

const checkAuthenticated = async () => {
  try {
    const response = await window.evite.fetch(urls.get('ajax_authenticated'), {
      credentials: 'include',
      headers: {
        'X-CSRFToken': evite.cookie('csrftoken'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();

    if (data && data.full_name) {
      saveUserDataToLocalStorage(data);
      return data;
    }
    return null;
  } catch (error) {
    localStorage.removeItem('userData');
    evite.error(`error: ${error}`);
    return null;
  }
};

const waitAuthenticated = (popup) => {
  return (accept, reject) => {
    const checkPopup = async () => {
      if (popup.closed) {
        const user = await checkAuthenticated();
        if (!user) {
          localStorage.removeItem('userData');
          reject();
          return;
        }
        saveUserDataToLocalStorage(user);
        accept(user);
      } else {
        setTimeout(checkPopup, 100);
      }
    };
    checkPopup();
  };
};

export const googlePlusConnect = async (marketingOptIn = false) => {
  window.tags.page_event('google_plus_connect');
  const w = 580;
  const h = 400;
  const left = screen.width / 2 - w / 2;
  const top = screen.height / 2 - h / 2;

  // Get the base URL and append marketing parameter
  const googleConnectUrl = urls.get('google_plus_connect');

  // Append marketing parameter to the URL string
  const marketingParam = `marketing_opt_in=${marketingOptIn ? 'true' : 'false'}`;
  const separator = googleConnectUrl.includes('?') ? '&' : '?';
  const finalUrl = `${googleConnectUrl}${separator}${marketingParam}`;

  const popup = window.open(finalUrl, 'gp_auth', `width=${w},height=${h},top=${top},left=${left}`);
  if (popup === null) {
    // biome-ignore lint/suspicious/noAlert: Fix me!
    alert(
      'We tried to open a popup window to connect to Google Plus. Please enable popup windows in your browser.'
    );
    return null;
  }

  try {
    return await new Promise(waitAuthenticated(popup));
  } catch (_error) {
    return null;
  }
};

export const appleConnect = async (marketingOptIn = false) => {
  const w = 580;
  const h = 400;
  const left = screen.width / 2 - w / 2;
  const top = screen.height / 2 - h / 2;

  // Get the base URL and append marketing parameter
  const appleConnectUrl = urls.get('apple_connect');

  // Append marketing parameter to the URL string
  const marketingParam = `marketing_opt_in=${marketingOptIn ? 'true' : 'false'}`;
  const separator = appleConnectUrl.includes('?') ? '&' : '?';
  const finalUrl = `${appleConnectUrl}${separator}${marketingParam}`;

  const popup = window.open(
    finalUrl,
    'apple_auth',
    `width=${w},height=${h},top=${top},left=${left}`
  );

  if (popup === null) {
    // biome-ignore lint/suspicious/noAlert: Fix me!
    alert(
      'We tried to open a popup window to connect to Apple. Please enable popup windows in your browser.'
    );
    return null;
  }

  try {
    return await new Promise(waitAuthenticated(popup));
  } catch (_error) {
    return null;
  }
};
